import axios from 'axios';

const formUrl = 'https://api.hsforms.com/submissions/v3/integration/submit/7663692/b482bb7f-4f8e-4cce-919b-34118189acd2';

export default function submitFormReal(submitData, {
  setSubmitting,
  onSubmit,
  onSuccess,
  setError,
}) {
  axios.post(formUrl, submitData)
    .then(() => {
      setSubmitting(false);
      onSubmit(false);
      onSuccess();
    })
    .catch((error) => {
      if (error.response) {
        setError(error.response.data.errors);
      }
      setSubmitting(false);
      onSubmit(false);
    });
}
